"use client";

import Image from "next/image";
import Link from "next/link";

import { Badge } from "@/components/ui/badge";
import { withLanguagePrefix } from "@/lib/site-locale";
import type { SiteLanguage } from "@/lib/site-data";
import type { BandRecord } from "@/lib/site-queries";

function spotifyUrl(spotifyId: string): string {
  return `https://open.spotify.com/artist/${spotifyId}`;
}

// `language` is required so the artist link matches the current URL.
// Reading it from usePreferences() used to emit /en/artists/... on a /tr
// page because preferences hydrate from localStorage after SSR.
export function BandBadge({ band, language }: { band: BandRecord; language: SiteLanguage }) {
  const artistHref = withLanguagePrefix(`/artists/${encodeURIComponent(band.name)}`, language);

  return (
    <Badge variant="outline" className="inline-flex max-w-[16rem] items-center gap-1 border-border bg-muted text-foreground">
      <Link href={artistHref} className="block max-w-[13rem] truncate hover:text-emerald-700 dark:hover:text-emerald-100" title={band.name}>
        {band.name}
      </Link>
      {band.spotifyId ? (
        <a
          href={spotifyUrl(band.spotifyId)}
          target="_blank"
          rel="noreferrer"
          className="inline-flex size-4 items-center justify-center rounded-full border border-white/35 bg-black/60 text-white"
          aria-label={`Open ${band.name} on Spotify`}
          onClick={(event) => event.stopPropagation()}
          onMouseDown={(event) => event.stopPropagation()}
          onPointerDown={(event) => event.stopPropagation()}
        >
          <Image src="/spotify-icon.svg" alt="" width={10} height={10} className="size-2.5" aria-hidden="true" />
        </a>
      ) : null}
    </Badge>
  );
}
